<template>
  <div id="app">
    <!-- <input type="button" value="click" ref="addToHome" @click="manageA2HS"> -->
    <div id="buttomNavigation" v-bind:class="{gone: !this.$store.state.bottomNav}"
      class="fRow jCenter aCenter transition-medium">
      <router-link v-for="item in navArray" v-bind:key="item.id"
        :to="item.rout" class="fCol aCenter jCenter">
        <a class="btn fCol jCenter aCenter transition-fast">
          <i class="material-icons-round transition-medium">{{item.icon}}</i>
          <span class="bicon transition-fast">{{item.label}}</span>
          <div class="backCircle transition-cubic"></div>
        </a>
      </router-link>
    </div>
    <div v-if="deferredPrompt && showPop && !ios" class="installs fRow jCenter aCenter wrap"
      ref="prompt">
      <label>وب اپلیکیشن {{appName.faName}} با دستگاه شما سازگار است</label>
      <span>آیا مایل به نصب {{appName.faName}} هستید؟</span>
      <div class="btn install primary" v-ripple
        @click="promptInstall">نصب اپلیکیشن {{appName.faName}}</div>
      <div class="btn" v-ripple @click="hidePopup">نه مایل نیستم</div>
    </div>
    <!-- iosPlatforms -->
    <div v-if="ios"
      class="installs defWidth ios fRow jCenter aCenter wrap"
      ref="prompt">
      <label>وب اپلیکیشن {{appName.faName}} با دستگاه شما سازگار است</label>
      <span>برای نصب اپلیکیشن {{appName.faName}} ابتدا گزینه
        <div class="img share"></div> را لمس کنید، سپس
        گزینه‌ی Add to home screen <div class="img add"></div> را انتخاب کنید</span>
      <div class="btn install primary" v-ripple  @click="hidePopup">متوجه شدم</div>
      <div class="fullWidth fCol jEnd aCenter">
        <i class="material-icons-round arr">keyboard_arrow_down</i>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import Theming from '@/mixins/theming';

export default {
  mixins: [Theming],
  data() {
    return {
      navArray: [
        {
          id: 1,
          label: 'خانــه',
          icon: 'home',
          rout: '/videos',
        },
        {
          id: 2,
          label: 'پیام‌رسان',
          icon: 'textsms',
          rout: '/chat',
        },
        {
          id: 3,
          label: 'کلاس',
          icon: 'school',
          rout: '/class',
        },
        {
          id: 4,
          label: 'آزمون',
          icon: 'check_box',
          rout: '/exam',
        },
        {
          id: 5,
          label: 'مشـاوره',
          icon: 'support_agent',
          rout: '/supporter',
        },
      ],
      showPop: true,
      ios: false,
      deferredPrompt: null,
    };
  },
  methods: {
    go(r) {
      setTimeout(() => {
        // this.drawerManager('close');
      }, 30);
      if (this.$router.currentRoute.fullPath !== r) {
        this.$router.push(r);
      }
      // console.log(this.$router.currentRoute.fullPath);
    },
    promptInstall() {
      // hide our user interface that shows our A2HS button
      this.hidePopup();
      // Show the prompt
      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            // console.log('User accepted the A2HS prompt');
          } else {
            // console.log('User dismissed the A2HS prompt');
          }
          this.deferredPrompt = null;
        });
    },
    hidePopup() {
      this.showPop = false;
    },
    getOs() {
      const [userAgent] = [window.navigator.userAgent];
      const [platform] = [window.navigator.platform];
      const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
      const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
      const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
      let os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
        this.ios = true;
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
      } else if (/Android/.test(userAgent)) {
        os = 'Android';
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
      }
      // this.$store.commit('setOs', os);
      return os;
    },
  },
  computed: {
    appName() {
      return this.$store.state.appName;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.ThemeInit();
    });
    if (!this.ios) {
      // deferredPrompt ↓
      let dp = null;
      window.addEventListener('beforeinstallprompt', (event) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        event.preventDefault();
        // Stash the event so it can be triggered later.
        dp = event;
        this.deferredPrompt = dp;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--normalText);
  background-color: var(--themeBackground);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.gone {
  bottom: -56px !important;
}
#buttomNavigation {
  position: fixed;
  z-index: 100000000000;
  padding: 0;
  background-color: var(--themeBackground);
  height: 56px;
  bottom: 0;
  box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.089), 0 -8px 24px 0 rgba(0, 0, 0, 0.096);
  left: 0;
  right: 0;
  overflow: hidden;

  a {
    font-weight: bold;
    color: #2c3e50;
    position: relative;
    margin: 0 0px;
    height: 100%;
    width: 30%;
    max-width: 112px;

    i{
      color: var(--secondary);
      text-shadow: 0 4px 8px rgba(0, 0, 0, 0.0);
    }

    span {
      font-size: 10px;
      font-weight: 100;
      color: var(--secondary);
    }

    .backCircle{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 0;
      height: 0px;
      pointer-events: none;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0);
    }

    &.router-link-exact-active{
      color: #fffb00 !important;

      i {
        color: rgb(97, 24, 122);
        font-size: 32px;
        z-index: 10;
      }

      span {
        font-size: 0px;
        font-weight: 300;
        color: white;
        z-index: 10;
      }
    }
  }
}

.installs {
  position: fixed;
  background-color: var(--themeBackground);
  top: 16px;
  left: 16px;
  right: 16px;
  max-width: 560px;
  z-index: 2000000000000000000;
  box-shadow: 0 24px 32px 0 var(--themeBlack2);
  border-radius: 8px;
  padding: 16px;
  label {
    width: 100%;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    color: var(--normalText);
    padding-bottom: 8px;
    border-bottom: dashed 1px rgba(0, 0, 0, 0.089);
    margin-bottom: 8px;
  }
  span {
    width: 100%;
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    color: var(--normalText);
    margin-bottom: 8px;
  }
  .btn {
    padding: 8px 12px;
    border-radius: 8px;
    margin: 0 4px;
    text-align: center;
    font-size: 13px;
    font-weight: 300;
    color: var(--normalText);
  }
  .btn.install {
    padding: 8px 12px;
    border-radius: 8px;
    margin: 0 4px;
    text-align: center;
    font-size: 13px;
    font-weight: bold;
    color: var(--themeBackground);
  }
}

.installs.ios {
  position: fixed;
  background-color: var(--themeBackground);
  bottom: 0;
  top: unset;
  right: unset;
  left: 50%;
  width: 100%;
  max-width: 480px !important;
  transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  max-width: unset;
  z-index: 2000000000000000000;
  box-shadow: 0 -24px 32px 0 rgba(0, 0, 0, 0.189);
  border-radius: 8px 8px 0 0;
  padding: 16px 16px 0;
  .arr {
    margin: 12px 0;
  }
  label {
    width: 100%;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    color: var(--normalText);
    padding-bottom: 8px;
    border-bottom: dashed 1px rgba(0, 0, 0, 0.089);
    margin-bottom: 8px;
  }
  span {
    width: 100%;
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    color: var(--normalText);
    margin-bottom: 8px;
    .img {
      max-height: 16px;
      display: inline-block;
      width: 24px;
      min-height: 16px;
      margin: 0 2px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .share {
      background-image: url('./assets/share.svg');
      min-width: 24px;
    }
    .add {
      background-image: url('./assets/add.svg');
      min-width: 16px;
    }
  }
  .btn {
    padding: 8px 12px;
    border-radius: 8px;
    margin: 0 4px;
    text-align: center;
    font-size: 13px;
    font-weight: 300;
    color: var(--normalText);
  }
  .btn.install {
    padding: 8px 12px;
    border-radius: 8px;
    margin: 0 4px;
    text-align: center;
    font-size: 13px;
    font-weight: bold;
    color: var(--themeWhite);
  }
}

// span.bicon{
//   font-size: 10px;
//   color: rgba(255, 255, 255, 0.363);
// }

</style>
